export const Bio = {
    name: "Shusrita",
    roles: [
      "Software Engineer",
      "Machine Learning Engineer",
      "Data Scientist",
      "Salesforce Developer"
    ],
    description:
      "I'm currently pursuing my MS in Information Science at the University of Pittsburgh, gearing up for graduation in April 2025.",
    description1:
      "With 3 years of professional experience as a Software Engineer, I’ve built scalable e-commerce solutions with Salesforce Commerce Cloud. Now, I’m diving deep into Machine Learning—crafting state-of-the-art models and curating high-quality datasets to power the next wave of AI innovation.",
    description2: 
    "And when I’m not immersed in research, coding, or fixing bugs, you'll catch me singing. It's my creative outlet that keeps me balanced and inspired.",
    description3:
    "Explore my journey, projects, and blog as I continue to innovate, collaborate, and break new ground in the tech world.",
    github: "https://github.com/shusritavenugopal",
    resume:
      "https://drive.google.com/file/d/1K1JVmbU2fvY2NCcCORU950BdzbwWU8Qw/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/shusrita-venugopal/",
    email: "shusritavenugopal@gmail.com",
    medium: "https://medium.com/@shusritavenugopal"
  };

export const skills = [
  {
    title: "Web Dev",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "Flutter",
        image:
          "https://cdn-images-1.medium.com/max/1200/1*5-aoK8IBmXve5whBQM90GA.png",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Java",
        image: "https://img.icons8.com/color/480/java-coffee-cup-logo--v1.png",
      },
      {
        name: "R",
        image: "https://img.icons8.com/external-becris-flat-becris/64/external-r-data-science-becris-flat-becris.png",
      },
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Python",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Salesforce commerce cloud",
        image: "https://upload.wikimedia.org/wikipedia/commons/6/64/SalesForce.jpg",
      },
    ],
  },
  {
    title: "Database",
    skills: [
      {
        name: "MySQL",
        image:
          "https://www.mysql.com/common/logos/logo-mysql-170x115.png",
      },
      {
        name: "MongoDB Atlas",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Cassandra",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/5/5e/Cassandra_logo.svg",
      }
    ],
  },
  {
    title: "AI and Cloud",
    skills: [
      {
        name: "Machine Learning",
        image:
          "https://img.icons8.com/stickers/100/artificial-intelligence.png",
      },
      {
        name: "Generative AI",
        image:
          "https://img.icons8.com/nolan/256/chatgpt.png",
      },
      {
        name: "Explainable AI",
        image:
          "https://img.icons8.com/plasticine/100/ai.png",
      },
      {
        name: "AWS",
        image:
          "https://img.icons8.com/color/480/amazon-web-services.png",
      },
      {
        name: "GCP",
        image:
          "https://avatars.githubusercontent.com/u/2810941?s=200&v=4",
      }
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-plain.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://blog.postman.com/wp-content/uploads/2014/07/logo.png",
      },
    ],
  },
];
export const experiences = [
  {
    id: 0,
    img: "",
    role: "Graduate Research Assistant - Machine Learning Engineer",
    company: "University of Pittsburgh",
    date: "May 2024 - present",
    desc: `Leading an AWS-funded research initiative to develop supervised machine learning models for predicting and mitigating bottlenecks in cloud-hosted streaming ecosystems. Designed predictive models to proactively alert stakeholders about emerging constraints, enabling strategic planning and fostering resilient, adaptive digital ecosystems. \n
          Data Engineering & Machine Learning Contributions:
          - Designed scalable ETL (Extract, Transform, Load) pipelines for ingesting and processing large volumes of structured and unstructured data from Patents, Amazon, WRDS, and SDC, reducing processing time by 50%.
          - Developed advanced data wrangling techniques, including feature engineering, dimensionality reduction, and anomaly detection, to enhance model performance. \n
          - Integrated multi-source data from APIs, relational databases, and cloud-based platforms, ensuring high data integrity and consistency.
          Machine Learning & Predictive Modeling:
          - Built and deployed BERT-based NLP models and vector embeddings to extract insights from large text datasets, enabling data-driven decision-making in the streaming services industry. 
          - Achieved 85% prediction accuracy in identifying system bottlenecks, leading to 40% reduction in decision latency and $100K cost savings for cloud infrastructure optimization.
          - Applied causal analysis and experimental design techniques to refine prediction models and optimize business strategies.
    `,
    skills: [
      "Machine Learning", 
      "Supervised Learning",
      "Text Classification",
      "ETL Pipelines (Extract, Transform, Load)",
      "Feature Engineering",
      "BERT models",
      "Natural Language Processing",
      "Data Engineering",
      "Data Processing",
      "Predictive Modeling & Forecasting", 
      "Python",
      "Pandas", "NumPy", "SciPy",
      "AWS", "System Bottleneck Analysis"
    ],
    doc: "",
  }, 
  {
    id: 1,
    img: "",
    role: "Graduate Teaching Assistant",
    company: "University of Pittsburgh",
    date: "August 2023 - Present",
    desc: `As a Graduate Teaching Assistant (GTA), I support undergraduate and graduate students in developing a strong foundation in programming, computer architecture, formal languages, and discrete mathematics. My role involves conducting recitations, grading assignments, and mentoring students to enhance their problem-solving skills and conceptual understanding. \n
    Courses Assisted:
    - Intermediate Programming in Java – Assisted students with object-oriented programming (OOP), data structures, and algorithms, reinforcing best coding practices and debugging techniques.
    - Computer Organization and Assembly Language – Guided students in low-level programming, CPU architecture, and memory management, providing hands-on experience with assembly language coding.
    - Formal Languages and Automata Theory – Helped students grasp regular expressions, finite automata, and context-free grammars, ensuring a deep understanding of theoretical computing concepts.
    - Discrete Mathematics – Led problem-solving sessions on logic, set theory, combinatorics, graph theory, and proofs, strengthening students' analytical thinking.`,
    skills: [
      "Java",
      "Data Structures",
      "Algorithm Design and Analysis",
      "Formal Languages & Automata Theory",
      "Problem Solving",
      "Logical Reasoning",
      "Collaboration with Undergratuate students",
      "Mentoring & Student Guidance", 
      "Assignment Grading & Feedback",
      "Enhancing Problem-Solving & Analytical Thinking"
    ],
    doc: "",
  },
  {
    id: 3,
    img: "",
    role: "Software Development Engineer",
    company: "Merkle, Dentsu Global Services",
    date: "October 2020 - July 2023",
    desc: `As an SDE at Merkle, I developed and optimized scalable B2C e-commerce solutions on Salesforce Commerce Cloud (SFCC) for global brands like Under Armour, Ralph Lauren, Kimberly-Clark, and Eileen Fisher. My role involved designing high-performance architectures, integrating third-party services, and enhancing customer experience through data-driven personalization. \n
    Key Achievements & Contributions:
    - Optimized Checkout Process & Payment Integrations: * Optimized checkout flow by refactoring and streamlining backend logic, reducing transaction times by 15% and cart abandonment by 10%, leading to a $2M revenue increase.
    - Integrated Klarna and Apple Pay payment solutions, increasing successful transactions by 15%, contributing to $30K in incremental revenue and enhancing customer satisfaction.
    - Buy-Online-Pickup-In-Store (BOPIS) Feature Development: Led the full-cycle development of BOPIS, a major omnichannel feature, enabling seamless online purchases with in-store pickups. * Achieved 700+ weekly BOPIS orders, increasing in-store foot traffic by 80% and contributing to $5K in additional sales per week.
    - Personalized Recommendation Engine & Customer Engagement: Developed a Salesforce Einstein-powered recommendation engine using machine learning algorithms, increasing: Average Order Value (AOV) by 15% and Customer retention by 10%, improving Customer Lifetime Value (CLV).
    - Mastered ISML, JavaScript, Java, and SFCC to develop scalable e-commerce functionalities.
    - Worked extensively with Storefront Reference Architecture (SFRA) to optimize page load times and user experience.
    - Resolved 5,000+ critical bugs, improving system stability and customer satisfaction.
    - Partnered with UX designers, business analysts, and backend engineers to reduce project development time by 15%.
    - Ensured seamless integration between frontend and backend components, aligning with industry best practices.`,
    skills: [
      "Salesforce Commerce Cloud", 
      "Java",
      "Javascript",
      "AJAX",
      "jQuery",
      "Internet Store Markup Language", 
      "Storefront Reference Architecture",
      "Salesforce Einstein",
      "High-Performance Architecture Design",
      "Backend Logic Optimization",
      "Scalable E-Commerce Solutions",
      "Payment Solutions Integration",
      "Transaction Optimization & Payment Gateway Integration",
      "Customer Experience Enhancement",
      "Collaborative Development"
    ],
    doc: "",
  },
  {
    id: 4,
    img: "",
    role: "Software Development Intern",
    company: "Merkle, Dentsu Global Services",
    date: "Jan 2020 - May 2020",
    desc: `As an SDE intern, I gained hands-on experience in developing scalable e-commerce solutions, working alongside senior engineers to implement high-impact features and optimizations. \n
    Key Projects & Contributions:
    - Developed a scalable return processing system, reducing return handling times by 35%, saving the company $700K annually in operational costs.
    - Designed and implemented a loyalty program leveraging customer data analytics, leading to: 25% increase in customer retention and $350K in repeat revenue
    - Completed an extensive Salesforce Commerce Cloud (SFCC) & Storefront Reference Architecture (SFRA) training, earning the Salesforce B2C Commerce Developer certification with 90% accuracy.
    - Built server-side components using ISML, JavaScript, and Java, gaining expertise in backend e-commerce architecture.
    - Integrated SFCC with third-party APIs, payment gateways, and middleware platforms, ensuring seamless data flow across systems.
    - Resolved 300+ technical issues and performance bugs, improving site reliability and checkout efficiency.
    - Worked closely with senior engineers, participating in code reviews, knowledge-sharing sessions, and best practices discussions to enhance code quality and performance.`,
    skills: [
      "Salesforce Commerce Cloud",
      "Java",
      "Javascript",
      "AJAX",
      "jQuery",
      "API Integration",
      "Server-Side Development",
      "E-Commerce System Design & Architecture",
      "Scalable System Design",
      "Customer Data Analytics",
      "A/B Testing",
      "Pipeline Profiling",
      "Bug Fixing",
      "Technical Training & Certification"

    ],
    doc: "",
  }
];

export const projects = [
  {
    id: 0,
    title: "Visualizing Our World: Stories Told Through Data",
    date: "Dec 2024",
    description:
      "Developed an interactive visualization project that analyzed global patterns and trends across six key indicators, enabling insights into economic, environmental, and social disparities. ",
    image:
      "https://media.licdn.com/dms/image/v2/D4E2DAQF-W1k2A0LzfA/profile-treasury-image-shrink_800_800/B4EZWRbVVBHgAY-/0/1741901619393?e=1742508000&v=beta&t=Jk66SP1CnLGuLAKW-lWTjB1FPhAOQ8t0NiKJKQLzVRU",
    tags: [
      "Data Visualization",
      "Data Analysis and Processing",
      "Python",
      "Matplotlib",
      "Geopandas",
      "Shapely.geometry",
      "Information Visualization",
      "Geospatial Insights"
    ],
    category: "machine learning",
    github: "https://github.com/shusritavenugopal/Global-Country-Information-Dataset-2023",
    webapp: "https://private-user-images.githubusercontent.com/63789652/393720511-13df4cdf-3b9f-4c96-9a74-7ff455585a1d.png?jwt=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJnaXRodWIuY29tIiwiYXVkIjoicmF3LmdpdGh1YnVzZXJjb250ZW50LmNvbSIsImtleSI6ImtleTUiLCJleHAiOjE3NDE0ODQ0NDUsIm5iZiI6MTc0MTQ4NDE0NSwicGF0aCI6Ii82Mzc4OTY1Mi8zOTM3MjA1MTEtMTNkZjRjZGYtM2I5Zi00Yzk2LTlhNzQtN2ZmNDU1NTg1YTFkLnBuZz9YLUFtei1BbGdvcml0aG09QVdTNC1ITUFDLVNIQTI1NiZYLUFtei1DcmVkZW50aWFsPUFLSUFWQ09EWUxTQTUzUFFLNFpBJTJGMjAyNTAzMDklMkZ1cy1lYXN0LTElMkZzMyUyRmF3czRfcmVxdWVzdCZYLUFtei1EYXRlPTIwMjUwMzA5VDAxMzU0NVomWC1BbXotRXhwaXJlcz0zMDAmWC1BbXotU2lnbmF0dXJlPWFkYWJjYTBiYmViZDI2ODM0OTQ5Yjk2ZDgzNjczNTAyOTM3MTJmN2ZjZjM5ZGJmYjNkOTAyZTI2MmZjYTk5YTAmWC1BbXotU2lnbmVkSGVhZGVycz1ob3N0In0.Jl5-Jt3Kq1mh7n-2YdWK8HUjJH2RKnaxtOqSfh_loCY",
  },
  {
    id: 0,
    title: "YouTube Safety Index: A Retrieval and Classification System",
    date: "Dec 2024",
    description:
      "Developed a comprehensive monitoring system for parents/guardians to classify and analyze YouTube content accessed by children, ensuring content safety through Information Retrieval (IR) and Machine Learning (ML) techniques. The system achieved 83% accuracy in classifying videos and provided actionable insights with real-time alerts.",
    image:
      "https://media.licdn.com/dms/image/v2/D4E2DAQHbAarKRiylKQ/profile-treasury-image-shrink_800_800/B4EZWRXVcEHUAg-/0/1741900568910?e=1742508000&v=beta&t=5e1vUAUKekd7b5M5rDWF_ynOpaKlSnQ3w1d4xofpJgU",
    tags: [
      "Machine Learning",
      "Information Storage & Retrieval",
      "Natural Language Processing",
      "BERT",
      "Elasticsearch",
      "Python",
      "Lexicon-based Filtering"
    ],
    category: "machine learning",
    github: "https://github.com/shusritavenugopal/Youtube_Safety_Index_ISR_Project",
    webapp: "",
  },
  {
    id: 0,
    title: "PPG Paints - Predicting and Classifying Paint Color Trends",
    date: "March 2024",
    description:
      "This project leverages exclusive data provided by PPG Industries, a global leader in paints and coatings. Using machine learning techniques, the project analyzes PPG's extensive library of paint colors to uncover patterns associated with top-selling paint products and the factors influencing their success.",
    image:
      "https://media.licdn.com/dms/image/v2/D4E2DAQHhXQvuERRmNQ/profile-treasury-image-shrink_800_800/B4EZWRY7TbGgAY-/0/1741900986806?e=1742508000&v=beta&t=XNHZhjPCWehbvC9K6U4Mb8vJBy0LMZY2u650HStinEY",
    tags: [
      "R Language",
      "Statistical Analysis",
      "Regression Analysis",
      "Classification Task",
      "Linear models",
      "Feature engineering",
    ],
    category: "machine learning",
    github: "https://github.com/shusritavenugopal/PPG-Industries-PaintLibrary-Analysis",
    webapp: "https://devpost.com/software/mindmate-your-ai-powered-mental-health-companion",
  },
  {
    id: 0,
    title: "Amazon Web Services DeepRacer Student League",
    date: "Oct 2024",
    description:
      "The AWS DeepRacer Student League brings an incredible opportunity for students worldwide to dive into the world of reinforcement learning, race their models, and win exciting prizes and scholarships! 🚗💨 I had the privilege to participate in the 2024 AWS DeepRacer Student League.",
    image:
      "https://media.licdn.com/dms/image/v2/D5622AQHqsI98RuXZmg/feedshare-shrink_2048_1536/B56ZSUcx2.HQAs-/0/1737657360320?e=1744243200&v=beta&t=B9GYitgND34QdfXoN9Nxwb6NDzXko6PMejXikCaxPqw",
    tags: [
      "Reinforcement Learning",
      "Machine Learning",
      "Python"
    ],
    category: "machine learning",
    github: "",
    webapp: "https://www.linkedin.com/posts/shusrita-venugopal_awsdeepracer-awsaimlscholarship-machinelearning-activity-7288263219805073409-8QzJ?utm_source=share&utm_medium=member_desktop&rcm=ACoAACVJWzABz2s5ZJZxiL9cddt1SDqE1lzCXgs",
  },
  {
    id: 0,
    title: "Whispers of the Heart",
    date: "May 2024",
    description:
      "Whispers of the Heart is a daily reflection journalling app that revolutionizes therapy by seamlessly integrating AI analysis with professional therapy practices.",
    image:
      "https://d112y698adiu2z.cloudfront.net/photos/production/software_photos/002/887/237/datas/original.png",
    tags: [
      "GCP",
      "Python",
      "Machine Learning",
      "Generative AI",
      "Google Gemini 1.5 pro",
    ],
    category: "machine learning",
    github: "https://github.com/shusritavenugopal/Whispers-of-the-Heart",
    webapp: "https://devpost.com/software/mindmate-your-ai-powered-mental-health-companion",
  },
  {
    id: 1,
    title: "Teera",
    date: "June 2024",
    description:
      "Spinal muscular atrophy (SMA) is a rare, inherited neuromuscular disorder that causes muscle weakness. We created Teera, an assistive agent app designed to help parents of children with SMA.",
    image:
      "https://d112y698adiu2z.cloudfront.net/photos/production/software_photos/002/922/322/datas/original.jpg",
    tags: [
      "GCP",
      "Flutter",
      "Machine Learning",
      "Generative AI",
      "Google Gemini",
      "Google VertexAI Agent Builder",
      "Dart"
    ],
    category: "machine learning",
    github: "https://github.com/shusritavenugopal/sma-assistive-agents",
    webapp: "https://devpost.com/software/sma-assistant-app?ref_content=user-portfolio&ref_feature=in_progress",
  },
  {
    id: 2,
    title: "Blockchain-Assisted Verifiable Cassandra",
    date: "Mar 2024 - Apr 2024",
    description:
      "In the Blockchain-assisted Verifiable Cassandra project, I deployed Apache Cassandra on AWS, achieving 99.9% uptime. By integrating MHT and Ethereum blockchain, query security was boosted, and authentication time slashed by 95%. Python scripts and smart contracts enabled secure interactions for 50+ users.",
    image:
      "https://media.licdn.com/dms/image/v2/D4E2DAQHXaSNsMNLCxg/profile-treasury-image-shrink_800_800/B4EZWRZmt9HMAY-/0/1741901164467?e=1742508000&v=beta&t=ePM0hPEtdLYXL0Ngvzy-weuLw5v3l1ng-nP41peTZiU",
    tags: [
      "Cassandra",
      "Python",
      "CQL",
      "BlockChain",
      "Ethereum",
      "Smart Contracts"
    ],
    category: "cloud",
    github: "https://github.com/shusritavenugopal/Blockchain-assisted-Verifiable-Cassandra"
  },
  {
    id: 3,
    title: "The PartyRock Generative AI Hackathon by AWS: Build With AWS",
    date: "Mar 2024 - Mar 2024",
    description:
      "The app streamlines project input, analyzing details like descriptions and algorithms. It then generates a custom list of AWS solutions, aligning perfectly with project needs.",
    image:
      "https://assets.community.aws/a/2dVef7UjNekXv5HDHeNDakAHo8E/Build.webp",
    tags: [
      "Python (Programming Language)",
      "Amazon Bedrock",
      "Retrieval Augmented Generation (RAG)",
      "Generative AI",
      "Amazon OpenSearch Serverless",
      "Amazon SageMaker Studio"
    ],
    category: "machine learning",
    github: "https://devpost.com/software/build-with-aws",
    webapp: "https://community.aws/content/2dUK1A3E8iaozHjSP41yLyu4pYi/build-with-aws",
  },
  {
    id: 3,
    title: "Global Hack Week: AI/ML Hackathon - MovieHub",
    date: "Feb 2024 - Feb 2024",
    description:
      "Movie streaming platform powered by MySQL HeatWave and Oracle APEX, offers personalized recommendations. This app also got me an interview at Oracle.",
    image:
      "https://d112y698adiu2z.cloudfront.net/photos/production/software_photos/002/765/124/datas/original.jpeg",
    tags: [
      "MySQL HeatWave Database System",
      "OLAP/AutoML",
      "Oracle Application Express",
      "RESTful WebServices",
    ],
    category: "machine learning",
    github: "https://github.com/shusritavenugopal/MovieHub-OracleAI-ML",
    webapp: "https://devpost.com/software/moviehub",
  },
  {
    id: 4,
    title: "Panther Training Club",
    date: "March 2024 - Apr 2024",
    description:
      "Panther Training Club is a comprehensive fitness web application built using Node.js, Express.js, MongoDB, JavaScript, and EJS templating framework. It caters to gym enthusiasts by providing a platform to register, log in, and book trainers for health and training purposes. The application offers distinct user roles for gym members, trainers, and administrators.",
    image:
      "https://d112y698adiu2z.cloudfront.net/photos/production/software_photos/002/922/326/datas/original.jpg",
    tags: [
      "Node.js",
      "Express.js",
      "MongoDB Atlas",
      "RESTful WebServices",
      "JavaScript",
      "EJS",
      "JWT",
      "NPM",
      "MVC architecture"
    ],
    category: "web app",
    github: "https://github.com/shusritavenugopal/panther-training-club",
    webapp: "https://panther-training-club.glitch.me",
  },
];

export const education = [
  {
    id: 0,
    img: "https://upload.wikimedia.org/wikipedia/en/f/fb/University_of_Pittsburgh_seal.svg",
    school: "University of Pittsburgh, Pittsburgh PA",
    date: "Aug 2023 - Apr 2025",
    grade: "3.84",
    desc: `KEY COURSES: \n Machine Learning, 
    Information Storage & Retrieval, Human-Robot Interaction, Cloud Computing, Information Security & Privacy, Human Information Processing`,
    degree: "MS in Information Science",
  },
  {
    id: 1,
    img: "https://d30mzt1bxg5llt.cloudfront.net/public/uploads/images/_signatoryLogo/DSI-Logo.jpg",
    school: "Dayananda Sagar College of Engineering",
    date: "Aug 2016 - May 2020",
    grade: "9.02",
    desc: `KEY COURSES: Artificial Intelligence, Computer Vision, Computer Graphics, Software Engineering, Data Structures, Algorithm Design & Analysis, Database Management Systems`,
    degree: "BE in Computer Science and engineering",
  },
];

export const blogs = [
  {
    id: 0,
    title: "Of Course, You’ve Heard of DeepSeek — But Do You Know What Makes It Tick?",
    date: "Feb 1, 2025",
    description:
      "Unless you’ve been completely off the grid, you’ve probably heard of DeepSeek. The emergence of DeepSeek, a cutting-edge Chinese AI model, has triggered a strong reaction in the U.S for the right reasons",
    image:
      "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*fddbPzPKYC9ddB1Pgvsrdg.png",
    tags: [
      "DeepSeek",
      "Reinforcement Learning",
      "GenerativeAI",
      "AI Agents",
      "Large Language Models",
      "Supervised Fine Tuning",
      "Chain-of-thought"
    ],
    category: "machine learning",
    article: "https://medium.com/@shusritavenugopal/of-course-youve-heard-of-deepseek-but-do-you-know-what-makes-it-tick-f4031e5baefb",
  },
  {
    id: 0,
    title: "Exploring Apple Intelligence: The Intersection of Differential Privacy and Foundation Models",
    date: "Jan 2, 2025",
    description:
      "“So, Apple collects no data at all? You tell me, what would you do with a device full of data and intelligence applied to it?” my friend asked, with a hint of skepticism.",
    image:
      "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*bnge6CsAGOsdJWp4hVWhgw.png",
    tags: [
      "Apple Intelligence",
      "Large Language Models",
      "Privacy in AI",
      "Responsible AI",
      "Differential Privacy",
      "Apple’s Foundation Models"
    ],
    category: "machine learning",
    article: "https://medium.com/@shusritavenugopal/exploring-apple-intelligence-the-intersection-of-differential-privacy-and-foundation-models-92c894855ab1",
  },
  {
    id: 0,
    title: "G(I)RWM — Machine Learning Edition | Introduction: Day 1",
    date: "Mar 10, 2025",
    description:
      "I’m excited to start my first-ever series: Get Interview-Ready With Me: Machine Learning Edition.",
    image:
      "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*RGutywLsSxE9w_dYWSuvKg.png",
    tags: [
      "Machine Learning",
      "Supervised Learning",
      "Unsupervised Learning",
      "Reinforcement Learning",
      "Pattern Recognition"
    ],
    category: "machine learning",
    article: "https://medium.com/@shusritavenugopal/machine-learning-edition-g-i-rwm-day-1-f86bd297efab",
  },
]